import type { DBEquipmentItem } from "@/lib/db-types";

export interface EquipmentFilter {
  /** Avdelings-id, eller null for begge. */
  departmentId: string | null;
  /** Kategori-id, eller null for alle. */
  categoryId: string | null;
  search: string;
}

/** Søk på navn, serienummer og kommentar (merke og modell kommer med produktdata, VIB-2918). */
export function matchesSearch(item: DBEquipmentItem, search: string): boolean {
  const q = search.trim().toLowerCase();
  if (!q) return true;
  return [item.name, item.comment ?? "", ...item.serial_numbers].some((v) => v.toLowerCase().includes(q));
}

/** Avdeling og søk først, så antall per kategori (til chipene), så kategorien. */
export function filterEquipment(items: DBEquipmentItem[], filter: EquipmentFilter) {
  const scoped = items.filter(
    (i) => (filter.departmentId === null || i.department_id === filter.departmentId) && matchesSearch(i, filter.search),
  );
  const countsByCategory = new Map<string, number>();
  for (const i of scoped) countsByCategory.set(i.category_id, (countsByCategory.get(i.category_id) ?? 0) + 1);
  const rows = filter.categoryId === null ? scoped : scoped.filter((i) => i.category_id === filter.categoryId);
  return { rows, countsByCategory, scopedTotal: scoped.length };
}
